import { getIn, useFormikContext } from "formik";
import React from "react";

export function FormikClearErrorsOnChange() {
  const { values, errors, submitCount, setFieldError } = useFormikContext();
  const previousValuesRef = React.useRef(values);

  React.useEffect(() => {
    if (submitCount === 0) {
      previousValuesRef.current = values;
      return;
    }
    const paths = getErrorPaths(errors);
    for (const path of paths) {
      if (getIn(previousValuesRef.current, path) !== getIn(values, path)) {
        setFieldError(path, undefined);
      }
    }
    previousValuesRef.current = values;
  }, [values, errors, submitCount, setFieldError]);

  return null;
}

function getErrorPaths(errors: unknown, base: string = ""): string[] {
  if (errors == null) return [];
  const paths: string[] = [];
  if (Array.isArray(errors)) {
    errors.forEach((item, i) => {
      const path = `${base}[${i}]`;
      if (typeof item === "string") {
        if (item) paths.push(path);
      } else if (item && typeof item === "object") {
        paths.push(...getErrorPaths(item, path));
      }
    });
  } else if (typeof errors === "object") {
    for (const [key, value] of Object.entries(
      errors as Record<string, unknown>
    )) {
      const path = base ? `${base}.${key}` : key;
      if (typeof value === "string") {
        if (value) paths.push(path);
      } else if (value && typeof value === "object") {
        paths.push(...getErrorPaths(value, path));
      }
    }
  }
  return paths;
}
